/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-secrets/no-secrets */
import { useMemo } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { React, useEffect, useState, useContext } from 'react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './TFPACoverageData.metadata.json5';
import styles from './TFPACoverageData.module.scss';
import messages from './TFPACoverageData.messages';
import { IntlContext } from 'react-intl';

function TFPACoverageData(props) {
    const { claims } = props;
    const policy = claims;
    const translator = useContext(TranslatorContext);
    const showAdditionalFieldError = false;
    const intlContext = useContext(IntlContext);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const isTFPACoverageSummary = true;
     const [propertyLimit, setPropertyLimit] = useState('');
    const [sectionICoverages, setSectionICoverages] = useState([]);
    const [allCoverages, setAllCoverages] = useState([]);
    const [allEndorsements, setAllEndorsements] = useState([]);
    const isHomeownersType = _.get(policy, 'policyType') === 'Homeowners';
    const isDateOnOrAfter  = moment(policy.effectiveDate).isSameOrAfter(moment(policy.splitDeductibleStartDateExt), 'day');
    
    
    const sortedCoverages = allCoverages.sort((a, b) => {
        return (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0;
    });

    useEffect(() => {
        if (policy) {
            if (policy.lobs.homeowner) {
                setAllCoverages([
                    ...policy.lobs.homeowner.locations[0].coverages,
                    ...policy.coverages,
                ]);
            }
            setAllEndorsements(policy.endorsementDTO_TFPA);
        }
    }, [policy]);

        useEffect(() => {
            if (policy) {
                if (policy.lobs.homeowner) {
                    const coverage = policy?.lobs?.homeowner?.locations[0].coverages?.filter(cov  => cov.coverageTypeExt === 'HODW_Personal_Property_HOE');
                    // DE17659
                    if (coverage?.length > 0) {
                        const limit = (coverage[0].exposureLimit.amount) / 10;
                        const convertAmount = intlContext.formatNumber(limit, {
                            style: 'currency',
                            currency: 'USD'
                        })
                        setPropertyLimit(convertAmount)
                    }               
                }
            }
        }, [intlContext, policy]);
    
    const getSectionICoverages = () => {
        const secIDed = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HODW_SectionI_Ded_HOE');
        const dwelling = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HODW_Dwelling_Cov_HOE' || cov.coverageTypeExt === 'DPDW_Dwelling_Cov_HOE');
        const otherStructures = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HODW_Other_Structures_HOE' || cov.coverageTypeExt === 'DPDW_Other_Structures_HOE');
        const personalProperty = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HODW_Personal_Property_HOE' || cov.coverageTypeExt === 'DPDW_Personal_Property_HOE');
        const lossOfUse = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HODW_Loss_Of_Use_HOE');
    
        return [...sectionICoverages, ...secIDed, ...dwelling, ...otherStructures, ...personalProperty, ...lossOfUse];
    };
    
    const getSectionIICoverages = () => {
        const newSectionIICoverages = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HOLI_Med_Pay_HOE' || cov.coverageTypeExt === 'HOLI_Personal_Liability_HOE');
        return newSectionIICoverages;
    };
    
    const getAdditionalLiabilityCoverages = () => {
        const newAdditionalLiabilityCoverages = allEndorsements?.filter(end => end.formNumber === 'HO-205' || end.formNumber === 'HO-225');
        return newAdditionalLiabilityCoverages;
    };
    
    const getAdditionalPropertyCoverages = () => {
        const newAdditionalPropertyCoverages = allEndorsements?.filter(end => (
            end.formNumber === 'HO-301' || end.formNumber === 'HO-802' || end.formNumber === 'HO-803' || end.formNumber === 'HO-804' ||
            end.formNumber === 'HO-382' || end.formNumber === 'HO-809' || end.formNumber === 'TDP_017' || end.formNumber === 'TDP-820'
        ));
        const endorsements = sortedCoverages?.filter(cov => cov.coverageTypeExt === 'HO400' || cov.coverageTypeExt === 'HO401');
        
        return [...newAdditionalPropertyCoverages, ...endorsements];
    };
    
    const secICoverages = getSectionICoverages();
    const secIICoverages = getSectionIICoverages();
    const liabilityCoverages = getAdditionalLiabilityCoverages();
    const propertyCoverages = getAdditionalPropertyCoverages();
    
    const getName = (item) => {
        return item.name;
    };
    
    const getDeductible = (item, index) => {
        // US31673
        const isSectionIDed = item.coverageTypeExt === 'HODW_SectionI_Ded_HOE';
        let deductibleValue;
        
        if (isHomeownersType && isDateOnOrAfter && isSectionIDed) {
            deductibleValue = _.get(
                _.find(item.covTermsExt, {
                    covPatternExt: 'HODW_OtherPerils_Ded_HOE'
                }),
                'financialAmountExt'
            );
        } else {
            deductibleValue = item.deductible;
        }

        if (_.isUndefined(deductibleValue) && isSectionIDed) {
            return <div>{propertyLimit}</div>;
        }

        return _.isUndefined(deductibleValue) ? '' : (
            <CurrencyField
                id={`premium_${index}`}
                value={deductibleValue}
                dataType="object"
                readOnly
                hideLabel
            />
        );
    };

    // US31673
    const getWindOrHailDeductible = (item, index) => {
        if (item.coverageTypeExt === 'HODW_SectionI_Ded_HOE') {
            const windOrHail = _.find(item.covTermsExt, {
                covPatternExt: 'HODW_WindHail_Ded_HOE'
            });

            if (_.get(windOrHail.financialAmountExt, 'amount') === 0) {
                return <div className={styles.naTextStyle}>N/A</div>;
            }
            
            return _.isUndefined(windOrHail.financialAmountExt) ? '' : (
                <CurrencyField
                    id={`premium_${index}`}
                    value={windOrHail.financialAmountExt}
                    dataType="object"
                    readOnly
                    hideLabel
                />
            );
        }
    };
    
    const getLimit = (item, index) => {
        return (_.isUndefined(item.exposureLimit)) ? '' : (
            <CurrencyField
                id={`premium_${index}`}
                value={item.exposureLimit}
                dataType="object"
                readOnly
                hideLabel
            />
        );
    };

     const getAggregateLimit = (item, index) => {
            return (_.isUndefined(item.formNumber)) ? 
                <CurrencyField
                    id={`premium_${index}`}
                    value={item.aggregateLimit}
                    dataType="object"
                    readOnly
                    hideLabel
                />
                : '';
        };
        
        const getAggregateLimitName = (item) => {
            return (_.isUndefined(item.formNumber)) ? <p>{translator(messages.limit)}</p> : '';
        };
    
    const getLimitHeader = (item, index) => {
        const exposure = (item?.exposureLimit) ? 
            <CurrencyField
                id={`premium_${index}`}
                value={(item?.exposureLimit) ? item.exposureLimit : ''}
                dataType="object"
                readOnly
                hideLabel
            /> : '';
        const incident = (item?.incidentLimit) ?  
            <CurrencyField
                id={`premium_${index}`}
                value={(item?.incidentLimit) ? item.incidentLimit : ''}
                dataType="object"
                readOnly
                hideLabel
            /> : '';
        return (
            <div>
                {exposure}
                {incident}
            </div>
        );
    };
    const getLimitNames = (item) => {
        const person = (item?.exposureLimit) ? <p>{translator(messages.perPerson)}</p> : '';
        const accident = (item?.incidentLimit) ? <p>{translator(messages.perAccident)}</p> : '';
        return (
            <div>
                {person}
                {accident}
            </div>
        );
    };
    
    const getPropertyName = (item) => {
        if (item.formNumber === undefined) {
            return `${item.name}`;
        }
        return `${item.formNumber} ${item.formDescription}`;
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        sectionICoveragesTitle: {
            visible: secICoverages.length !== 0
        },
        sectionICoveragesTable: {
            visible: secICoverages.length !== 0,
            data: secICoverages
        },
        sectionIICoveragesTitle: {
            visible: secIICoverages.length !== 0
        },
        sectionIICoveragesTable: {
            visible: secIICoverages.length !== 0,
            data : secIICoverages
        },
        additionalPropertyCoveragesTitle: {
            visible: propertyCoverages.length !== 0 
        },
        propertyCoveragesTable: {
            visible: propertyCoverages.length !== 0,
            data : propertyCoverages
        },
        additionalLiabilityCoveragesTitle: {
            visible: liabilityCoverages.length !== 0,
        },
        liabilityCoveragesTable: {
            visible: liabilityCoverages.length !== 0,
            data : liabilityCoverages
        },
        deductibleColumn: {
            header: isHomeownersType && isDateOnOrAfter ? translator(messages.otherPerilsDeductible) : translator(messages.deductible)
        },
        deductibleWindOrHailColumn: {
           visible: secICoverages.length !== 0 && isHomeownersType && isDateOnOrAfter
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getName,
            getDeductible,
            getWindOrHailDeductible,
            getLimit,
            getLimitHeader,
            getLimitNames,
            getPropertyName,
            getAggregateLimit,
            getAggregateLimitName
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={claims}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

TFPACoverageData.propTypes = {
    data: PropTypes.shape({}),
};

export default TFPACoverageData;